import axios from "../../util/axios";

const PREFIX_URI = "/luqiao/contract/worker";

export default {
    /** 查询列表 */
    list: (data) => axios.get({url: `${PREFIX_URI}/list`, data: data}),

    /** 保存 */
    saveSubmit:  (data) => axios.post({url: `${PREFIX_URI}/saveSubmit`, data: data}),

    /** 删除 */
    delete: (id) => axios.get({url: `${PREFIX_URI}/delete`, data: {id: id}}),

    /** 查询单条 */
    findById: (id) => axios.get({url: `${PREFIX_URI}/findById`, data: {id: id}}),

    /** 查询劳务人员履历 */
    queryWorkerHistory: (workerId) => axios.get({url: `${PREFIX_URI}/queryWorkerHistory`, data: {workerId: workerId}}),
}